/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React from "react";
import classes from "./css.module.css";
import ErrorMsg from "../../../component/ErrorMsg";
import { connect } from "react-redux";

const BottomHeader = (props) => {
  var extension = undefined;
  if (props.tenantData.logo) {
    if (props.tenantData.logo.startsWith("data:image")) {
      extension = "";
    } else {
      let decoded = atob(decodeURIComponent(props.tenantData.logo));
      var lowerCase = decoded.toLowerCase();
      if (lowerCase.indexOf("png") === 1) {
        extension = "png";
      } else if (
        lowerCase.indexOf("jpg") === 1 ||
        lowerCase.indexOf("jpeg") === 1
      ) {
        extension = "jpg";
      } else if (lowerCase.includes("svg")) {
        extension = "svg+xml";
      } else if (
        lowerCase.indexOf("tif") === 1 ||
        lowerCase.indexOf("tiff") === 1
      ) {
        extension = "tiff";
      }
    }
  }
  return (
    // <div className={'bottomHeaderNoAuth'}>
    //     <div className={classes.innerBottomHeader}>
    //         <div className={classes.leftInnerBottomHeader}>
    //             <a href='/#' className={classes.mainLogo}>
    //                 {props.tenantData.logo &&
    //                     <img src={'data:image/' + extension + ';base64,' + encodeURIComponent(props.tenantData.logo)} alt={props.tenantData.title} />
    //                 }
    //             </a>
    //         </div>
    //     </div>
    //     <div style={{ minHeight: '30px' }}></div>
    //     <ErrorMsg />
    // </div>
    <>
      <div className={"newTopHeader"}>
        <div className={classes.topHeaderLogo} align="left">
          <a href="/">
            {props.tenantData.logo ? (
              <>
                {props.tenantData.logo.startsWith("data:image") ? (
                  <img
                    src={props.tenantData.logo}
                    alt={props.tenantData.title}
                  />
                ) : (
                  <img
                    src={
                      "data:image/" +
                      extension +
                      ";base64," +
                      encodeURIComponent(props.tenantData.logo)
                    }
                    alt={props.tenantData.title}
                  />
                )}
              </>
            ) : (
              <img src="" alt={props.tenantData.title} />
            )}
            {/* {props.tenantData.logo ?
                        :
                        <img src={defaultLogo} alt='Digitize Things' />
                    } */}
          </a>
        </div>
        <div className={classes.topHeaderCart} align="right">
          <label style={{ color: props.tenantData.color }}>
            {props.tenantData.title}
          </label>
        </div>
        {/* <div className="cl"></div> */}
      </div>
      <div
        className={classes.newBottomHeader}
        style={{ backgroundColor: props.tenantData.color, height: "50px" }}
        align="center"
      ></div>
      <ErrorMsg />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    tenantData: state.auth.tenantData,
  };
};

export default connect(mapStateToProps)(BottomHeader);
